import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ClienteLogin, Cliente } from '../../../views/login/cliente_login';
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { ContactenosService } from './../contactenos/contactenos.service';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import jQuery from "jquery";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ContactosTecniMasivosEntity } from "../datosGenerales/entities/contactos_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { JwtHelper } from "angular2-jwt/angular2-jwt";

@Component({
    selector: 'infoContactenos',
    providers: [ContactenosService],
    templateUrl: 'contactenos.template.html'
})

export class Contactenos implements OnInit {
    cliente: Cliente;
    usuario: ClienteLogin;
    private url = "infoClienteIndividual";
    contactos: ContactosTecniMasivosEntity[];
    jwtHelper: JwtHelper = new JwtHelper();
    telefono: string;

    constructor(
        private contactenosService: ContactenosService,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        public sesionStorageService: SessionStorageService

    ) {


    }

    ngOnInit(): void {
        try {

            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    this.cliente = jQuery.parseJSON(this.sesionStorageService.retrieve("usermasivos"));
                    this.CargarTodo();
                    this.sesionStorageService.observe("usermasivos").subscribe(usuario => {
                        try {
                            this.cliente = jQuery.parseJSON(usuario);
                        } catch (error) {
                            this.cliente = usuario;
                        }
                        this.CargarTodo();
                    });
                }
            }
        } catch (ex) {

        }
    }

    CargarTodo() {
        if(this.cliente != null)
        {
        this.contactenosService.datosContactos(this.cliente).subscribe(
            datosContactos => {
                this.contactos = datosContactos;
                this.telefono = this.contactos[0].TelefonoContacto;
            },
            error => { this.handleError.redirectUrl(error); });
        }        
    }

}







// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/contactenos/contactenos.component.ts